<div class="base-component component-white">
  <div fxFill fxLayout="row">
    <div fxFlex="auto" fxLayoutAlign="center center">
      <img class="avatar" src="assets/img/avatar.png">
    </div>
    <div fxFlex="95" fxLayout="column" fxLayoutGap="5px">
      <h4 class="title text-hard-blue">{{ showName }}</h4>
      <p>{{ item.added_at }}</p>
    </div>
  </div>

  <mat-divider></mat-divider>

  <div fxFill fxLayout="row">
    <div fxFlex="auto" fxLayoutAlign="center start" class="icon">
      <mat-icon>chat_bubble_outline</mat-icon>
    </div>
    <div fxFlex="95" fxLayout="column" class="text">
      <div [innerHTML]="item.description"></div>
    </div>
  </div>

  <div *ngIf="item?.files.length > 0">
    <app-call-attachments
      [files]="item.files"
    ></app-call-attachments>
  </div>

</div>
